import React, { ComponentType, Component } from "react";
import { Redirect } from "react-router-dom";
import jwt from "jsonwebtoken";
import config from "./config/setting";
import { connect } from "react-redux";
import { logoutUser } from "../redux/actions/user";

interface WithAuthInjectedProps {
  roleId: any;
}

interface WithAuthDispatchProps {
  logoutUser: () => void;
}

interface WithAuthState {
  roleId: any;
  invalid: boolean;
  checked: boolean;
}

export function withAuth<P extends object>(
  WrappedComponent: ComponentType<P & WithAuthInjectedProps>
) {
  class WithAuth extends Component<P & WithAuthDispatchProps, WithAuthState> {
    constructor(props: P & WithAuthDispatchProps) {
      super(props);
      this.state = {
        roleId: null,
        invalid: false,
        checked: false,
      };
    }

    componentDidMount() {
      const token = sessionStorage.getItem("token");

      if (!token) {
        this.setState({ invalid: true, checked: true });
        return;
      }

      jwt.verify(token, config.secretKey, (err: any, decoded: any) => {
        if (err) {
          this.props.logoutUser();
          this.setState({ invalid: true, checked: true });
        } else {
          this.setState({ roleId: decoded.role, checked: true });
        }
      });
    }

    render() {
      const { roleId, invalid, checked } = this.state;

      if (invalid) {
        return <Redirect to="/" />;
      }

      if (!checked) {
        // Optionally render a loader while we verify the token
        return null;
      }

      return <WrappedComponent {...(this.props as P)} roleId={roleId} />;
    }
  }

  const mapDispatchToProps = {
    logoutUser,
  };

  // Loosen the typing on the returned component to avoid TS complexity here.
  // The wrapped component will still receive the correct runtime props.
  return connect(
    null,
    mapDispatchToProps
  )(WithAuth as any) as ComponentType<P>;
}


